import React, { useState } from "react";
import { Divider, IconButton, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import useStyles from '../../assets/styles/styles';
import StarIcon from '@material-ui/icons/Star';
import { useHistory } from "react-router-dom";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useResizeScreen } from "../../hooks/useResizeScreen";
import { selectCommunication, modifyCommunication } from "../../redux/actions/communicatedAction";

const CommunicationDetail = () => {

    const communicationSelected = useSelector(state => state.communicatedReducer?.communicationSelected);
    const history = useHistory();
    const dispatch = useDispatch();
    const { screen } = useResizeScreen();
    const classes = useStyles();
    const [favorite, setFavorite] = useState(communicationSelected?.favourite);

    const handlClickFavorite = (e) => {
        e.preventDefault();
        let communicationArray = [];
        communicationArray.push(communicationSelected);
        let newCommunication = communicationArray?.map(item => {
            return { ...item, favourite: !item.favourite };
        });
        dispatch(selectCommunication(newCommunication[0]));
        dispatch(modifyCommunication(newCommunication[0]));
        setFavorite(prevState => !prevState);
    };
    const isFavorite = () => {
        let response = '';
        if (favorite) {
            response = classes.iconDestacate;
        }
        return response;
    };

    const showDate = () => {
        const dateStar = communicationSelected?.initialDate?.split('T')[0];
        if (!dateStar) return null;

        const [year, month, day] = dateStar.split("-");
        return (
            <Typography className={classes.initialDateCardCommunication}>
                {`${day}/${month}/${year}`}
            </Typography>
        );
    };

    return (
        <>
            <div style={{ padding: '3%' }}>
                <section className={classes.communicationDetail}>
                    <IconButton onClick={() => history.push('/AllCommunications')}>
                        <ArrowBackIcon className={classes.iconFilter} />
                    </IconButton>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {screen.sWidth < 768 && showDate()}
                    </div>
                    <IconButton onClick={handlClickFavorite}>
                        <Typography className={`${classes.txtSubtitle}`} style={{ fontSize: '11px', fontWeight: 'bold' }}>
                            AGREGAR DESTACADO
                        </Typography>
                        <StarIcon className={`${classes.iconDestacateCommunicationDetail} ${isFavorite()}`} />
                    </IconButton>
                </section>
                <article >
                    <div className={classes.startDateCardCommunicationWeb}>
                        <Typography className={`${classes.mainTitle} ${classes.txtSubtitle}`} style={{ fontSize: '22px' }} >{communicationSelected?.title}</Typography>
                        {screen.sWidth > 768 && showDate()}
                    </div>
                    <Divider />
                    <div>
                        <Typography className={classes.txtDescriptionTitleCardCommunication} >Descripción: </Typography>
                        <div className={classes.txtDescriptionCardCommunication} dangerouslySetInnerHTML={{ __html: communicationSelected?.description }} />
                    </div>
                    <section className={classes.txtAuthorCardCommunications} >
                        {communicationSelected?.author !== '' && (
                            <Typography className={classes.txtDescriptionTitleCardCommunication}> Este es un mensaje de: {communicationSelected?.author} </Typography>
                        )}
                    </section>
                    {communicationSelected?.image64 &&
                        <aside className={classes.titleImagenCardCommunications}>
                            <img className={classes.styleImagenCardCommunications} src={communicationSelected?.image64} alt='imgNotificacion' />
                        </aside>
                    }
                </article>
            </div>
        </>
    );
};

export default CommunicationDetail;